import LocalizedStrings from 'react-localization';

import en from './en.json';

export const locale = new LocalizedStrings({ en });
